import React, { type FC, useMemo, useState } from 'react';

import { Flex, useDisclosure } from '@chakra-ui/react';
import { motion } from 'framer-motion';

import { Viewport } from '@/components/Viewport';
import {
  AdminLayoutContext,
  type AdminLayoutContextNavDisplayed,
  type AdminLayoutContextValue,
} from '@/features/admin/AdminLayoutContext';

import { MainSidebar } from './MainSidebar';

const MotionFlex = motion(Flex);

export const AdminMainLayout: FC<
  React.PropsWithChildren<{
    navHidden?: boolean;
  }>
> = ({ navHidden = false, children }) => {
  const [navDisplayed, setNavDisplayed] =
    useState<AdminLayoutContextNavDisplayed>(!navHidden);
  const navDrawer = useDisclosure();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const providerValue = useMemo(
    () =>
      ({
        navDisplayed,
        setNavDisplayed,
        navDrawer,
      }) satisfies AdminLayoutContextValue,
    [navDisplayed, navDrawer]
  );

  return (
    <AdminLayoutContext.Provider value={providerValue}>
      <Viewport bg="gray.25" direction="row">
        <Flex flexShrink={0}>
          <MainSidebar
            isCollapsed={isCollapsed}
            setIsCollapsed={setIsCollapsed}
          />
        </Flex>
        <Flex flex={1}>
          <MotionFlex h="100vh" flex={1} direction="column" overflowY="auto">
            {children}
          </MotionFlex>
        </Flex>
      </Viewport>
    </AdminLayoutContext.Provider>
  );
};
